import React from 'react';

import { CheckIcon, DataTable, type TableColumn } from '@/src/ui';
import { ReportHeaderStyle, ReportCellStyle } from '@/src/utils';
import type { SubmissionHistoryRowDTO } from '@/src/dtos/Reports/SubmissionHistoryDTO';

type SubmissionHistoryTableProps = {
    rows: SubmissionHistoryRowDTO[];
};

const SubmissionHistoryTable: React.FC<SubmissionHistoryTableProps> = ({ rows }) => {
    const columns: TableColumn[] = [
        {
            dataKey: 'studentName',
            header: 'Student',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'className',
            header: 'Class',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'examName',
            header: 'Exam',
            align: 'left',
            allowSort: true,
            emptyValue: '-',
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
        },
        {
            dataKey: 'status',
            header: 'Status',
            align: 'left',
            allowSort: true,
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: SubmissionHistoryRowDTO) => {
                if (!r.status)
                    return <CheckIcon color="green" style={{ width: '24px', height: '24px' }} />;
                else return r.status;
            },
        },
        {
            dataKey: 'score',
            header: 'Score',
            align: 'left',
            allowSort: true,
            headerSx: ReportHeaderStyle,
            cellSx: ReportCellStyle,
            formatter: (r: SubmissionHistoryRowDTO) =>
                r.score != null ? `${Math.max(r.score, 0)}%` : '-',
        },
    ];

    return (
        <DataTable
            columns={columns}
            data={rows}
            tableName="Submission History"
            rowsPerPageInitial={50}
            enableExportCSV
            alternatingRowColor
        />
    );
};

export default SubmissionHistoryTable;
